/**
 * Business-day arithmetic — V98-0-4. The one calculator behind every
 * `bizdays` timeframe, forwards (after-notices, remediation windows) and
 * backwards (before-notices). A business day is a UTC calendar day that is
 * neither a Saturday/Sunday nor an observed US federal holiday; the holiday
 * convention is stated in data/us-federal-holidays.ts.
 */
import { isUsFederalHoliday } from '../data/us-federal-holidays.js';
export function isBusinessDay(d) {
    const day = d.getUTCDay();
    return day !== 0 && day !== 6 && !isUsFederalHoliday(d);
}
/**
 * Step `n` business days from `start` (negative = backwards), keeping the
 * time of day. The start day itself never counts. Fractions round away from
 * zero, so a partial day can only lengthen an after-window or move a
 * before-notice earlier.
 */
export function addBusinessDays(start, n) {
    const step = n < 0 ? -1 : 1;
    const d = new Date(start.getTime());
    let left = Math.ceil(Math.abs(n));
    while (left > 0) {
        d.setUTCDate(d.getUTCDate() + step);
        if (isBusinessDay(d))
            left--;
    }
    return d;
}
//# sourceMappingURL=business-days.js.map